module.exports = __webpack_public_path__ + "files/0a20843511f86650ae9e2ff5774f05be.png";